module.exports = [{"name":"dat-firstload","type":"dev-app-toronto","link":"myp3:ca_on_toronto_cty_toronto_devappaic","isOn":false,"isDefault":true,"opacity":1,"format":"image/png8","isPng":true,"size":256},{"name":"dat-main","type":"dev-app-toronto","link":"myp3:myp_devapp_filter_gs","isOn":false,"isDefault":true,"opacity":1,"format":"image/png8","isPng":true,"size":256}]


//////////////////
// WEBPACK FOOTER
// ./public/data/filter-layers-wms.json
// module id = QQK4
// module chunks = 1